export default {
  "b2b.provozni-informace-cards.empty": "Žádné provozní informace",
  "b2b.provozni-informace-card.delete-dialog.title":
    "Odstranit provozní informaci",
  "b2b.provozni-informace-card.delete-dialog.confrimMessage":
    "Skutečně si přejete odstranit provozní informaci?"
};
